import { render, staticRenderFns } from "./Drives.vue?vue&type=template&id=71c15b48&"
import script from "./Drives.vue?vue&type=script&lang=js&"
export * from "./Drives.vue?vue&type=script&lang=js&"
import style0 from "./Drives.vue?vue&type=style&index=0&id=71c15b48&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports